import { render, staticRenderFns } from "./Outlets.vue?vue&type=template&id=2b0562b8&lang=html"
import script from "./Outlets.vue?vue&type=script&lang=js"
export * from "./Outlets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports